import React from 'react';
import { Check, Lock, MessageSquare } from 'lucide-react';

export const TaskRow = ({ task, blockers, onToggle, onOpen }) => {
  const done = task.status === 'Done';
  const locked = !done && blockers.length > 0;
  return (
    <div data-testid={`task-row-${task.task_id}`}
      className={`group flex items-start gap-3 px-4 py-3 border-b border-stone-100 last:border-0 transition-colors ${locked ? 'bg-stone-50/60' : 'hover:bg-amber-50/40'}`}>
      <button
        data-testid={`task-toggle-${task.task_id}`}
        onClick={() => onToggle(task)}
        disabled={locked}
        title={locked ? 'Finish the linked tasks first' : done ? 'Mark as pending' : 'Mark as done'}
        className={`mt-0.5 w-5 h-5 shrink-0 rounded-md border flex items-center justify-center transition-all duration-200 ${
          done ? 'bg-lime-700 border-lime-700 scale-100' : locked ? 'border-stone-300 bg-stone-100 cursor-not-allowed' : 'border-stone-400 hover:border-amber-700 hover:scale-110'
        }`}>
        {done ? <Check className="w-3.5 h-3.5 text-white" /> : locked ? <Lock className="w-3 h-3 text-stone-400" /> : null}
      </button>
      <button onClick={() => onOpen(task)} data-testid={`task-open-${task.task_id}`} className="flex-1 text-left min-w-0">
        <p className={`text-sm ${done ? 'line-through text-stone-400' : locked ? 'text-stone-500' : 'text-stone-900'}`}>{task.title}</p>
        {locked && (
          <p className="text-[11px] text-amber-800 mt-0.5 truncate" data-testid={`task-blockers-${task.task_id}`}>
            Waiting on: {blockers.map(b => b.title).join(', ')}
          </p>
        )}
        {done && task.completed_by && (
          <p className="text-[11px] text-stone-400 mt-0.5">Done by {task.completed_by} · {new Date(task.completed_at).toLocaleDateString('en-IN')}</p>
        )}
      </button>
      {task.notes?.length > 0 && (
        <span className="flex items-center gap-1 text-[11px] text-stone-500 mt-0.5" data-testid={`task-notes-count-${task.task_id}`}>
          <MessageSquare className="w-3.5 h-3.5" />{task.notes.length}
        </span>
      )}
    </div>
  );
};
